import Input from 'antd/lib/input';
import Switch from 'antd/lib/switch';
import Space from 'antd/lib/space';
import Tooltip from 'antd/lib/tooltip';
import Typography from 'antd/lib/typography';
import { ICustomerUtilityBill } from 'src/domain/customer-utility-bill/interface';
import { billLabelStyle } from '../billStyles';

const { Text } = Typography;

interface Props {
    form: ICustomerUtilityBill;
    handleChange: <K extends keyof ICustomerUtilityBill>(fieldName: K, value: ICustomerUtilityBill[K]) => void;
    // `verified` is the operator's intent. verifiedAt / verifiedBy are stamped server-side from the
    // request actor (@Actor decorator) on save — the client never sets them.
    verified: boolean;
    onVerifiedChange: (verified: boolean) => void;
    // A bill with no extracted data would be FAILED on save and so can't be verified — gate the toggle on this.
    canVerify: boolean;
    // View-only bills (not yet parsed / download-failed) open read-only — notes + verify are shown but disabled.
    disabled?: boolean;
}

export const BillReviewSection = ({ form, handleChange, verified, onVerifiedChange, canVerify, disabled }: Props) => (
    <>
        <div style={{ marginBottom: 14 }}>
            <Text style={billLabelStyle}>OPERATOR NOTES</Text>
            <Input.TextArea
                rows={3}
                placeholder="Add a note for other operators…"
                value={form.notes || ''}
                onChange={e => handleChange('notes', e.target.value)}
                disabled={disabled}
            />
        </div>

        <div style={{ marginBottom: 14 }}>
            <Space>
                <Tooltip title={canVerify ? '' : 'Add billing data before this bill can be verified'}>
                    <Switch checked={verified && canVerify} disabled={!canVerify || disabled} onChange={onVerifiedChange} />
                </Tooltip>
                <Text type={canVerify ? undefined : 'secondary'}>Mark as verified</Text>
            </Space>
        </div>
    </>
);
